import React, { FC, ReactNode } from 'react';
import { ControlErrorMessages, Dropdown, requestResourceByName, Resource, ResourceProps, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StyledLink } from './DropdownLoader.styles';

export interface DropdownLoaderProps extends Omit<ResourceProps<{}, {}>, 'children'> {
  children: ReactNode;
}

const DropdownLoader: FC<DropdownLoaderProps> = ({ name, children, ...props }) => {
  const { t } = useTranslation('DropdownLoader');
  const dispatch = useDispatch();
  const res: { error: unknown; pending: boolean } = useScopedSelector(name);
  return (
    <>
      <Resource
        name={name}
        {...props}
      />
      {(!res || res.pending) && <Dropdown emptyLabel={res?.pending ? t('dropdownLoadingText') : null} disabled aria-label={t('disabled')} />}
      {res?.error &&
        <>
          {!res.pending && <Dropdown isValid={false} isTouched aria-label={t('error')} />}
          <ControlErrorMessages
            messages={{
              loadingError: t('dropdownLoadingError'),
            }}
            errors={{
              loadingError: true,
            }}
          />
          <StyledLink data-testid="retryDropdownLink" onClick={() => dispatch(requestResourceByName(name))}>{t('retryLinkText')}</StyledLink>
        </>}
      {res && !res.pending && !res.error && children}
    </>
  );
};
export default DropdownLoader;
